export const type = 'form.googleReCaptchaV2';
